import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalDialog,
  Typography,
  FormControl,
  FormLabel,
  Input,
  Select,
  Option,
  Button,
  Box
} from '@mui/joy';
import { toast } from 'react-toastify';
import { authFetch } from '../utils/authFetch'; // usa authFetch come nel resto

export default function ModaleMezzo({ open, onClose, onSuccess }) {
  const [nomeMezzo, setNomeMezzo] = useState('');
  const [codiceMezzo, setCodiceMezzo] = useState('');
  const [tipoMezzo, setTipoMezzo] = useState('');
  const [categoriaId, setCategoriaId] = useState('');
  const [categorie, setCategorie] = useState([]);

  const [conventions, setConventions] = useState([]);
  const [type_convention, settype_convention] = useState('');

  const selectedOrg = localStorage.getItem('selectedOrg');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !selectedOrg) return;

    const load = async () => {
      try {
        const [resCategorie, resConvention] = await Promise.all([
          authFetch(`${process.env.REACT_APP_SERVER_HOST}/org/${selectedOrg}/category`, {
            credentials: 'include',
          }),
          authFetch(`${process.env.REACT_APP_SERVER_HOST}/org/${selectedOrg}/convention`, {
            credentials: 'include',
          }),
        ]);

        if (!resCategorie.ok) throw new Error('Errore fetch categorie');
        if (!resConvention.ok) throw new Error('Errore fetch convenzioni');

        const categorieData = await resCategorie.json();
        const conventionData = await resConvention.json();

        setCategorie(Array.isArray(categorieData) ? categorieData : []);
        setConventions(Array.isArray(conventionData) ? conventionData : []);
      } catch (err) {
        console.error(err);
        toast.error('Impossibile caricare dati modale');
        setCategorie([]);
        setConventions([]);
      }
    };

    load();
  }, [open, selectedOrg]);

  const reset = () => {
    setNomeMezzo('');
    setCodiceMezzo('');
    setTipoMezzo('');
    setCategoriaId('');
    settype_convention('');
    setLoading(false);
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  const handleSubmit = async () => {
    if (!nomeMezzo.trim() || !codiceMezzo.trim() || !tipoMezzo || !categoriaId) {
      toast.error('Compila tutti i campi obbligatori');
      return;
    }

    setLoading(true);

    try {
      const response = await authFetch(
        `${process.env.REACT_APP_SERVER_HOST}/org/${selectedOrg}/vehicle`,
        {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: nomeMezzo,
            code: codiceMezzo,
            type: tipoMezzo,
            category_id: categoriaId,
            type_convention: type_convention,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || 'Errore nella creazione del mezzo');
      }

      onSuccess?.();
      handleClose();
    } catch (err) {
      console.error('Errore creazione mezzo', err.message);
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <ModalDialog>
        <Typography level="h4" mb={2}>
          Nuova Risorsa
        </Typography>

        <FormControl required>
          <FormLabel>Nome Risorsa</FormLabel>
          <Input
            value={nomeMezzo}
            onChange={(e) => setNomeMezzo(e.target.value)}
            placeholder="Inserisci nome risorsa"
            disabled={loading}
          />
        </FormControl>

        <FormControl required sx={{ mt: 2 }}>
          <FormLabel>Codice Risorsa</FormLabel>
          <Input
            value={codiceMezzo}
            onChange={(e) => setCodiceMezzo(e.target.value)}
            placeholder="Inserisci codice"
            disabled={loading}
          />
        </FormControl>

        <FormControl required sx={{ mt: 2 }}>
          <FormLabel>Tipo Risorsa</FormLabel>
          <Select
            placeholder="Seleziona tipo risorsa"
            value={tipoMezzo}
            onChange={(e, value) => setTipoMezzo(value)}
            disabled={loading}
          >
            <Option value="1">Ambulanza</Option>
            <Option value="2">Automedica</Option>
            <Option value="3">Autoinfermieristica</Option>
            <Option value="4">ELI</Option>
            <Option value="5">Zaino</Option>
          </Select>
        </FormControl>

        <FormControl required sx={{ mt: 2 }}>
          <FormLabel>Categoria</FormLabel>
          <Select
            placeholder="Seleziona categoria"
            value={categoriaId}
            onChange={(e, value) => setCategoriaId(value)}
            disabled={loading || categorie.length === 0}
          >
            {categorie.map((c) => (
              <Option key={c.id} value={c.id}>
                {c.name}
              </Option>
            ))}
          </Select>
        </FormControl>

        <FormControl required sx={{ mt: 2 }}>
          <FormLabel>Convenzione</FormLabel>
          <Select
            placeholder="Seleziona convenzione"
            value={type_convention}
            onChange={(e, value) => settype_convention(value)}
            disabled={loading || conventions.length === 0}
          >
            {conventions.map((conv) => (
              <Option key={conv.id} value={conv.id}>
                {conv.name}
              </Option>
            ))}
          </Select>
        </FormControl>

        <Box mt={3} display="flex" justifyContent="flex-end" gap={1}>
          <Button variant="soft" onClick={handleClose} disabled={loading}>
            Annulla
          </Button>
          <Button
            onClick={handleSubmit}
            loading={loading}
            disabled={
              !nomeMezzo.trim() ||
              !codiceMezzo.trim() ||
              !tipoMezzo ||
              !categoriaId ||
              !type_convention
            }
          >
            Crea
          </Button>
        </Box>
      </ModalDialog>
    </Modal>
  );
}